module.exports = __webpack_public_path__ + "static/book-dont-get-screwed-600b2a772d28bb4c11c00b7004727e32.jpg";